export const GENERATE_GLOBAL_NORMS = "GENERATE_GLOBAL_NORMS"
export const GLOBAL_NORMS_LIST = "GLOBAL_NORMS_LIST"

export const CREATE_GROUP_NORMS = "CREATE_GROUP_NORMS"
export const GROUP_NORMS_LIST = "GROUP_NORMS_LIST"
export const GROUP_NORMS_DETAILS_LIST = "GROUP_NORMS_DETAILS_LIST"

export const NORMS_SUCCESS = "NORMS_SUCCESS"
export const NORMS_ERROR = "NORMS_ERROR"

